import { cn } from "@/lib/utils";
import {
  IconDiamond,
  IconHeart,
  IconShieldCheck,
  IconAward,
  IconUsers,
  IconSparkles,
} from "@tabler/icons-react";

const features = [
  {
    title: "איכות ללא פשרות",
    description: "כל תכשיט עובר בדיקה קפדנית לפני שהוא מגיע אליכם",
    icon: <IconDiamond className="w-6 h-6 text-primary" />,
  },
  {
    title: "שירות אישי וחם",
    description: "יחס אישי ומקצועי לכל לקוח, כמו משפחה",
    icon: <IconHeart className="w-6 h-6 text-primary" />,
  },
  {
    title: "אחריות מלאה",
    description: "אחריות מקיפה על כל מוצר ושירות תיקונים מקצועי",
    icon: <IconShieldCheck className="w-6 h-6 text-primary" />,
  },
  {
    title: "מקצועיות ואמינות",
    description: "צוות מומחים עם ניסיון של עשרות שנים בתחום",
    icon: <IconAward className="w-6 h-6 text-primary" />,
  },
  {
    title: "קהילה ומשפחתיות",
    description: "עסק משפחתי שמתייחס לכל לקוח כאל חבר",
    icon: <IconUsers className="w-6 h-6 text-primary" />,
  },
  {
    title: "חדשנות ועדכניות",
    description: "תמיד מעודכנים בטרנדים האחרונים מהעולם",
    icon: <IconSparkles className="w-6 h-6 text-primary" />,
  },
];

export function FeaturesSectionWithHoverEffects() {
  return (
    <div className="border border-border rounded-lg overflow-hidden max-w-7xl mx-auto" dir="rtl">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 relative z-10">
        {features.map((feature, index) => (
          <Feature key={feature.title} {...feature} index={index} />
        ))}
      </div>
    </div>
  );
}

const Feature = ({
  title,
  description,
  icon,
  index,
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
  index: number;
}) => {
  return (
    <div
      className={cn(
        "flex flex-col py-6 sm:py-8 lg:py-10 relative group/feature",
        // Vertical borders between columns (RTL layout)
        (index === 0 || index === 1 || index === 3 || index === 4) && "lg:border-l border-border",
        // Horizontal border between rows
        index < 3 && "lg:border-b border-border",
        // Mobile/Tablet borders - all except last get bottom border
        index < 5 && "border-b sm:border-b lg:border-b-0",
        index < 3 && "lg:border-b",
        // 2-column tablet borders
        (index === 0 || index === 2 || index === 4) && "sm:border-l sm:lg:border-l-0"
      )}
    >
      {index < 3 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-primary/5 to-transparent pointer-events-none" />
      )}
      {index >= 3 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-primary/5 to-transparent pointer-events-none" />
      )}
      <div className="mb-3 sm:mb-4 relative z-10 px-6 sm:px-8 lg:px-10 text-primary">{icon}</div>
      <div className="text-base sm:text-lg font-bold mb-1.5 sm:mb-2 relative z-10 px-6 sm:px-8 lg:px-10">
        <div className="absolute right-0 inset-y-0 h-5 sm:h-6 group-hover/feature:h-7 sm:group-hover/feature:h-8 w-1 rounded-tl-full rounded-bl-full bg-muted group-hover/feature:bg-primary transition-all duration-200 origin-center" />
        <span className="group-hover/feature:translate-x-2 transition duration-200 inline-block text-foreground">
          {title}
        </span>
      </div>
      <p className="text-xs sm:text-sm text-muted-foreground max-w-xs relative z-10 px-6 sm:px-8 lg:px-10 leading-relaxed">
        {description}
      </p>
    </div>
  );
};
